<template>
  <div class="nan-ticker">
    <button
      class="form-control"
      @click="$emit('input', value - 1)"
      :disabled="value <= min"
      type="button"
    >
      <span class="screen-reader-text">Remove one</span>
      -
    </button>

    <input
      ref="input"
      :id="id"
      :value="value"
      @input="onInput"
      @blur="onInput"
      type="number"
      :min="min"
      :max="max"
      class="form-control"
    />

    <button
      class="form-control"
      @click="$emit('input', value + 1)"
      :disabled="value >= max"
      type="button"
    >
      <span class="screen-reader-text">Add one</span>
      +
    </button>
  </div>
</template>

<script>
import id from "@/mixins/id";

export default {
  mixins: [id],

  props: {
    value: Number,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    }
  },

  methods: {
    onInput() {
      const el = this.$refs.input;
      el.value = Math.max(this.min, Math.min(this.max, +el.value));
      el.value = el.value || 0;
      this.$emit("input", +el.value);
    }
  }
};
</script>

<style lang="scss">
.nan-ticker {
  display: grid;
  grid-template-columns: auto 1fr auto;

  .form-control {
    flex-grow: 1;
    text-align: center;
  }

  button {
    width: auto;
  }

  input {
    border-radius: 0;
    border-right: 0;
    border-left: 0;
  }

  button:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
